import React from 'react'
import * as S from './styles'

const Header: React.FC = ({ children }) => <S.Header>{children}</S.Header>

export default Header
